import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BluetoothSerial } from "@ionic-native/bluetooth-serial";
import * as _ from "lodash";
import {
  BLImageOptions,
  BLPrinterUtils
} from "../../ext_src/BLPrinterUtils";
import moment from "moment";
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';


/*
  Generated class for the CbPrintingProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CbPrintingProvider {

  selectedPrinter: any = [];
  listBluetoothDevices: any = [];
  private _connected = false;

  constructor(public http: HttpClient,
    private bluetoothSerial: BluetoothSerial,

  ) {
    console.log('Hello CbPrintingProvider Provider');
  }

  //=========================================================================

  public connectToPrinter(): Promise<string> {


    var cbPromise = new Promise<string>(async (resolve, reject) => {
      if (this._connected == true) {
        resolve("OK")
        return cbPromise;
      }

      this._connectPrinter(async (success) => {

        //await this.bluetoothSerial.write("THE PRINTER IS CONNECTED")
        //await this.bluetoothSerial.clear();

        //   var node = new HTMLElement();
        //   node.innerHTML = `<div id="cbPrintArea">
        //   <h1>Test máy in </h1>
        // </div>`

        //   let dataURL = await htmlToImage.toPng(node);
        //   this.cbprint(dataURL);
        resolve("OK")
      }
        , (err) => {
          alert("Connect to printer failed" + JSON.stringify(err));
          resolve("Connect to printer failed" + JSON.stringify(err));
          //alert(err);

        });

    })
    return cbPromise;
  }



  //=========================================================================

  async print(data)  {
    if (this._connected == false)
    {
      await this.connectToPrinter();
      this.delay(2000)
    }
    let res = await this.bluetoothSerial.write(data);
    return res

    return 
    var cbPromise = new Promise<boolean>(async (resolve, reject) => {

      if (this._connected) {
        this.bluetoothSerial.write(data).then(
          (onOk) => { resolve(true) },
          (onReject) => { resolve(false) }
        )
      }
    })
    return cbPromise
  }

  async cbPrintESCPOS(pImageBase64) {

  }
  //=========================================================================


  // async cbprint(pImageBase64) {
  //   //alert("i am in cb Printing")
  //   console.log(pImageBase64)
  //   let res = await this.doPrintTicket(pImageBase64).then(
  //     (onOK) => {
  //       alert("PRINT OK" + JSON.stringify(onOK))
  //     },
  //     (onErr) => {
  //       alert("ERROR IN PRINTING" + JSON.stringify(onErr))

  //     }
  //   )

  //   //alert("RESULT " + JSON.stringify(res))

  // }

  //=========================================================================
  async delay(timeInMillis: number): Promise<void> {
    return new Promise(resolve => setTimeout(() => resolve(), timeInMillis));
  }

  //=========================================================================

  // Ensure connect to printer before print
  private _tryConnect(
    address: string,
    success: Function,
    error: Function,
    count: number = 0
  ) {
    count = count || 0;

    this.bluetoothSerial.connect(address).subscribe(
      () => {
        this._connected = true;
        success();
      },
      () => {
        if (count >= 5) {
          alert("erro connect");
          return error();
        }

        // retry connect 5 times before timeout
        count++;
        setTimeout(() => {
          this._tryConnect(address, success, error, count);
        }, 1000);
      }
    );
  }

  //=========================================================================

  async doPrintTicket(pImageBase64: string): Promise<boolean> {

    await this.bluetoothSerial.clear();
    this.delay(1000)
    var cbPromise = new Promise<boolean>(async (resolve, reject) => {

      var printList = BLPrinterUtils.textBold("") + "CTY TNHH MTV Thao Cam Vien SG \n";

      printList = printList + "Ve mua roi khong doi hoac tra \n";
      printList = printList + "Co gia tri ngay " + moment().format("DD/MM/YYYY") + "\n";

      var text = printList;

      const imageUrl = pImageBase64;

      const options: BLImageOptions = {
        dataUrl: imageUrl,
        maxWidth: 400,
        //maxHeight: 50
      };

      // let startIndex = pImageBase64.indexOf(",");
      // let imageBytes = pImageBase64.substring(startIndex+1);
      const ticketCodeQR = BLPrinterUtils.createQRCode(
        "ticketTrial",
        "\x04",
        "\x31"
      );
      const byteArray = await BLPrinterUtils.createImageByteArrayPromise(options);

      if (byteArray) {
        alert("BYETE ARRAY " + JSON.stringify(byteArray));
        // print image
        await this.print(BLPrinterUtils.ALIGN_CENTER);
        await this.print(text);
        await this.print(byteArray);
        await this.print(ticketCodeQR);
        await this.print("\n");
        await this.print(BLPrinterUtils.ALIGN_LEFT);
        await this.print(text);
        await this.print("\n");
        await this.print(BLPrinterUtils.textNormal(""))
        resolve(true);

      }
    })

    return cbPromise;
  }

  //=========================================================================

  private _connectPrinter(success: Function, error: Function) {
    if (this._connected) {
      return success();
    }

    this.bluetoothSerial
      .isConnected()
      .then(() => {
        this._connected = true;
        success();
      })
      .catch(() => {
        // Not connected
        this.bluetoothSerial
          .list()
          .then((devices: BluetoothDevice[]) => {
            // Connect first paired device
            if (devices.length > 0) {
              this._tryConnect(devices[0].address, success, error);
            } else {
              alert(
                "Không tìm/kết nối được với máy in. Chức năng in chỉ khả dụng cho phiên bản Android"
              );
              alert("erro connect");
            }
          })
          .catch(err => {
            //alert("Could not find any printer for print" + JSON.stringify(err));
            error("could not connect")
          });
      });
  }
}
//=========================================================================

export interface BluetoothDevice {
  name: string;
  address: string;
  type: string;
  id?: string;
}




// WEBPACK FOOTER //
// ./src/providers/cb-printing/cb-printing.ts